window.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll('.tab-button');
  const tabList = document.querySelector('.tab-menu');

  // Add a click event handler to each tab
  tabs.forEach((tab) => {
    tab.addEventListener("click", changeTabs);
  });

  // Enable arrow navigation between tabs in the tab list
  let tabFocus = 0;

  tabList.addEventListener("keydown", (e) => {
    // Move right
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      tabs[tabFocus].setAttribute("tabindex", -1);
      if (e.key === 'ArrowRight') {
        tabFocus++;
        // If we're at the end, go to the start
        if (tabFocus >= tabs.length) {
          tabFocus = 0;
        }
        // Move left
      } else if (e.key === 'ArrowLeft') {
        tabFocus--;
        // If we're at the start, move to the end
        if (tabFocus < 0) {
          tabFocus = tabs.length - 1;
        }
      }

      tabs[tabFocus].setAttribute("tabindex", 0);
      tabs[tabFocus].focus();
    }
  });
});

function changeTabs(e) {
  const target = e.target;
  const tabId = target.getAttribute("aria-controls");
  const grandparent = target.closest('.tab-grand');

  // Remove all current selected tabs
  grandparent
    .querySelectorAll('[aria-selected="true"]')
    .forEach((t) => {
      t.setAttribute("aria-selected", false);
      t.setAttribute("tabindex", -1);
    });

  // Set this tab as selected
  target.setAttribute("aria-selected", true);
  target.setAttribute("tabindex", 0);

  // Hide all tab panels
  grandparent
    .querySelectorAll('.tab-content')
    .forEach((p) => p.setAttribute("hidden", true));

  // Show the selected panel
  const selectedPanel = grandparent.querySelector(`#${CSS.escape(tabId)}`);
  if (selectedPanel) {
    selectedPanel.removeAttribute("hidden");
  }
}

// ==================================================
// Flavor ↔ Tab sync: auto-select the tab that matches
// the active flavor in the buy-box flavor picker.
// ==================================================
(function () {
  function getActiveFlavorLabel() {
    const activePill = document.querySelector(
      'flavor-picker [aria-current="true"]'
    );
    if (!activePill) return null;
    return (
      activePill.dataset.flavorLabel ||
      activePill.querySelector('.flavor-pill__label')?.textContent?.trim() ||
      null
    );
  }

  function activateMatchingTab(flavorLabel) {
    if (!flavorLabel) return;
    const normalised = flavorLabel.trim().toLowerCase();

    document.querySelectorAll('.section-tabbed-content').forEach((sectionEl) => {
      const tabs = sectionEl.querySelectorAll('.tab-button');
      for (const tab of tabs) {
        if (tab.textContent.trim().toLowerCase() === normalised) {
          // Only switch if not already active
          if (tab.getAttribute('aria-selected') !== 'true') {
            tab.click();
          }
          break;
        }
      }
    });
  }

  // Sync on flavor change
  document.addEventListener('lasso:product-info-updated', () => {
    // Small delay so the picker's selected state is fully committed
    requestAnimationFrame(() => activateMatchingTab(getActiveFlavorLabel()));
  });

  // Sync on initial page load
  document.addEventListener('DOMContentLoaded', () => {
    activateMatchingTab(getActiveFlavorLabel());
  });
})();

// ==================================================
// Tab rail arrows: scroll tabs left/right + enable/disable
// ==================================================
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".section-tabbed-content").forEach((sectionEl) => {
    const tabMenu = sectionEl.querySelector(".tab-menu");
    const prevBtn = sectionEl.querySelector(".tab-rail__arrow--prev");
    const nextBtn = sectionEl.querySelector(".tab-rail__arrow--next");

    if (!tabMenu || !prevBtn || !nextBtn) return;

    const updateArrows = () => {
      const maxScrollLeft = tabMenu.scrollWidth - tabMenu.clientWidth;
      prevBtn.disabled = tabMenu.scrollLeft <= 1;
      nextBtn.disabled = tabMenu.scrollLeft >= maxScrollLeft - 1;

      const hasOverflow = tabMenu.scrollWidth > tabMenu.clientWidth + 2;
      const nav = sectionEl.querySelector(".tab-rail__nav");
      if (nav) nav.style.display = hasOverflow ? "flex" : "none";
    };

    const scrollTabs = (dir) => {
      tabMenu.scrollBy({
        left: Math.round(tabMenu.clientWidth * 0.7) * dir,
        behavior: "smooth"
      });
    };

    prevBtn.addEventListener("click", () => scrollTabs(-1));
    nextBtn.addEventListener("click", () => scrollTabs(1));
    tabMenu.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    updateArrows();
  });
});
